import { awsApiInstanceV1 } from '../api/aws-api-v1';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ITransactionTableModel, ITransactionResponse } from '../models/transactions.interface'
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets a list of transactions based upon the logged in user.
 * 
 * @returns {Promise} the api response
 */
export const getTransactionsV1 = async (transaction: ITransactionTableModel): Promise<ITransactionResponse> => {
  try {
    apiRetry( awsApiInstanceV1);

    const { userId } = useAuth()!;

    const awsData = {
      wpId: userId,
      ...transaction
    }

    const response = await awsApiInstanceV1.get('/transaction/', { params: awsData });

    const { data = {} } = response || {};

    if ( data.errorMessage) {      
      const error = JSON.parse(data.errorMessage);
      handleRouteError(error, 'Error getting transaction data');
      throw new Error(data.errorMessage);
    }

    return data;
  } catch ( error: any ) {
    handleRouteError(error, 'Error getting transaction data');
    throw new Error(error);
  }
}